import{getMissingValue}from"./iterate/missing.js";
import{reduceParents}from"./reduce.js";
import{validateClasses}from"./validate.js";





export const set=(
target,
query,
value,
{
mutate=false,
missing=true,
leaves=false,
shallowArrays,
classes,
inherited
}={})=>

{
validateClasses(classes,mutate);
const setFunc=setEntry.bind(undefined,{value,mutate,missing,classes});
return reduceParents({
target,
query,
setFunc,
missing,
leaves,
shallowArrays,
classes,
inherited
})
};



const setEntry=({value,mutate,missing,classes},target,path,index)=>{
if(index===path.length){
return value
}

const prop=path[index];
const defaultedTarget=getMissingValue(target,prop,{missing,classes});
const childTarget=defaultedTarget[prop];
const childValue=setEntry(
{value,mutate,missing,classes},
childTarget,
path,
index+1
);
return setValue({target:defaultedTarget,prop,childValue,mutate})
};

export const setValue=({target,prop,childValue,mutate})=>
Array.isArray(target)?
setArrayValue({target,index:prop,childValue,mutate}):
setObjectValue({target,prop,childValue,mutate});

const setArrayValue=({target,index,childValue,mutate})=>{
if(isSameArrayValue(target,index,childValue)){
return target
}

const targetA=mutate?target:[...target];

targetA[index]=childValue;
return targetA
};



const isSameArrayValue=(target,index,childValue)=>
target[index]===childValue&&(
childValue!==undefined||index<target.length);

const setObjectValue=({target,prop,childValue,mutate})=>{
if(isSameObjectValue(target,prop,childValue)){
return target
}

const targetA=mutate?target:{...target};

targetA[prop]=childValue;
return targetA
};



const isSameObjectValue=(target,prop,childValue)=>
target[prop]===childValue&&(childValue!==undefined||prop in target);